import './App.scss';
import { FC } from 'react';
import AppRoutes from './routes/AppRoutes';
import BackToTop from './components/BackToTop/BackToTopComponent';
import { useLoadTrackingScript } from './hooks/useLoadTrackingScript';
import { useWidgetLoader } from './hooks/useWidgetLoader';
import ToastContainerComponent from './components/UI/ToastComponent/ToastContainerComponent/ToastContainerComponent';
import useScrollRestoration from './hooks/useScrollRestoration';
import { AuthActions } from './redux/AuthActions';
import { useTokenRefresher } from './hooks/useTokenRefresher';
import { useAuthCallback } from './hooks/useAuthCallbacks';
import { useAppDispatch } from './redux/store';
import useHasData from './hooks/useHasData';
// import { UserMenuState } from './components/authentication/user-menu/model';
// import { useSelector } from 'react-redux';
// import { RootState } from './redux/AppReducer';

export const App: FC = () => {
	const dispatch = useAppDispatch();
	const setIsRefreshingToken = (isRefreshing: boolean) => {
		dispatch(AuthActions.isRefreshingToken(isRefreshing));
	};
	// const [state] = useState({ ...UserMenuState });
	// const isAuthenticated = useSelector(
	// 	(state: RootState) => state.appState.authState?.isAuthenticated
	// );
	// const logout = useCallback(() => dispatch(AuthActions.logout()), [dispatch]);
	// console.log("Token: ", isAuthenticated, (!document.cookie.includes('IRIS_AUTH')));
	// useEffect(() => {
	// 	if ((!document.cookie.includes('IRIS_AUTH'))) {
	// 		console.log("No Cookies", localStorage.getItem('x-iiris-identity-userid'));
	// 		setTimeout(() => {
	// 			document?.getElementById(state.iirisLogoutButtonId)?.click();
	// 			logout();
	// 			// setTimeout(() => {
	// 			// 	window.location.href  = '/' ;
	// 			// },100)
	// 		},0);
	// 	}
	// }, [logout]);
	useWidgetLoader();
	useLoadTrackingScript();
	useScrollRestoration();
	useTokenRefresher(setIsRefreshingToken);
	useAuthCallback();
	useHasData();

	return (
		<div data-testid='app'>
			<ToastContainerComponent />
			<BackToTop />
			<AppRoutes />
		</div>
	);
};

export default App;
